import {
    Alert,
    AlertIcon,
    Box,
    Divider,
    Flex,
    Heading,
    HStack,
    Image,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    useDisclosure,
    useTheme,
    VStack,
} from '@chakra-ui/react';
import React, { useRef, useState } from 'react';
// import * as ga from '../../../canopy-ui-components/google-analytics';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchAllMenuThunk,
    selectAllMenu,
    selectAllMenuLoading,
} from '../../app-state/slices/AppDataSlice';
import { AppDispatch } from '../../app-state/store';
import CanopyButton from '../../canopy-ui-components/components/CanopyButton/CanopyButton';
import CanopyIconButton from '../../canopy-ui-components/components/IconButton/IconButton';
import { useCurrentColors } from '../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
import MenuMappingDetails, {
    MenuMappingDetailsSelector,
    MenuMappingDetailsType,
} from './MenuMappingDetails';
// import * as ga from '../../../canopy-ui-components/google-analytics';
import { isEmpty, sortBy, values } from 'lodash';
import apiClient, { ROLES } from '../../canopy-ui-components/api';
import * as ga from '../../canopy-ui-components/google-analytics/index';
import MenuMapping, {
    MENU_MAPPING_TYPES,
    MenuMappingSelector,
} from './MenuMapping';
interface Props extends PageComponentProps<any> {
    // mapping?: AnalyticsMapping[];
    showModal: boolean;
    setShowModal: (flag: boolean) => void;
    // refreshData: () => void;
    // globalProps: GlobalProps;
}

const prepareMenuDetails = (list: any) => {
    return list.map((menu: any, index: number) => {
        const { menu_id, sub_menu, excluded_on } = menu;
        return {
            menu_id,
            ...(sub_menu && { sub_menu: prepareMenuDetails(sub_menu) }),
            position: index + 1,
            excluded_on,
        };
    });
};

const validateMenu = (menu: any): boolean => {
    if (menu instanceof Array && menu?.length) {
        return menu.reduce((res: boolean, m: any) => {
            res = res && validateMenu(m);
            return res;
        }, true);
    } else if (menu.sub_menu?.length) {
        return menu.sub_menu.reduce((res: boolean, m: any) => {
            res = res && validateMenu(m);
            return res;
        }, true);
    } else {
        return !isEmpty(menu);
    }
};

const sortMenu = (list: any) => {
    return sortBy(
        list.map((menu: any, index: number) => {
            return {
                ...menu,
                ...(menu.sub_menu?.length && {
                    sub_menu: sortMenu(menu.sub_menu),
                }),
            };
        }),
        'position'
    );
};

const defaultDetails = {
    name: '',
    user: null,
    role: null,
    partner: null,
    device: null,
};

export const CreateOrEditMenuMappingModal = ({
    mappingData = {},
    showModal,
    setShowModal,
    globalProps,
    refreshData,
    copy,
    edit,
    ...props
}: any): any => {
    const currentColors = useCurrentColors();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { t } = globalProps;
    const theme = useTheme();
    const logo = theme?.images?.headerLogo;
    const [details, setDetails] =
        useState<MenuMappingDetailsType>(defaultDetails);
    const detailsRef = useRef<MenuMappingDetailsSelector>(null);
    const menuMappingRef = useRef<MenuMappingSelector>(null);
    const [menuDetails, setMenuDetails] = useState<{
        valid: boolean;
        data: any;
    }>();
    const [app, setApp] = useState('manager');
    const dispatch = useDispatch<AppDispatch>();

    const allMenuLoading = useSelector(selectAllMenuLoading);
    const allMenu = useSelector(selectAllMenu);

    const [status, setStatus] = useState<{
        state?: 'error' | 'loading' | 'success';
        message?: string;
    }>();
    const [appOptions, setAppOptions] = useState([]);

    useEffect(() => {
        (async () => {
            const data = await apiClient.getApps();
            const modifiedData: any = Object.entries(data).map(
                ([key, value]) => {
                    return {
                        key,
                        type: 'menu-appbar',
                    };
                }
            );
            !data?.error && setAppOptions(modifiedData);
        })();
    }, []);

    useEffect(() => {
        if (mappingData?.[0]) {
            const data = mappingData[0];
            setDetails({
                name: data.description,
                partner: data.partner_code
                    ? {
                          partnerCode: data.partner_code,
                          id: data.partner_id,
                          partnerName: data.partner_name,
                      }
                    : null,
                role:
                    ROLES.find((role: any) => role.value === data.role_id) ||
                    null,
                user: data.user_id
                    ? {
                          displayName: data.user_display_name,
                          id: data.user_id,
                      }
                    : null,
                device: data.device
                    ? {
                          label: data.device,
                          value: data.device,
                      }
                    : null,
            });
        }
    }, [mappingData, isOpen]);

    useEffect(() => {
        allMenuLoading === null && dispatch(fetchAllMenuThunk());
    }, [allMenuLoading]);

    const handleOnClose = React.useCallback(() => {
        ga.event({
            action: `${window.location.pathname.replace(
                '//g/',
                ''
            )} > Close Copy Mapping Modal`,
        });

        if (refreshData) {
            refreshData();
        }
        setApp('manager');
        setShowModal(false);
        setDetails(defaultDetails);
        setStatus({});
    }, []);

    useEffect(() => {
        showModal ? onOpen() : onClose();
    }, [showModal]);

    const prepareMenus = (menuLi: any) => {
        const newMenus = [];
        const hasMappedMenu = mappingData?.[0]?.details.some(
            (app1: any) => app1.app_id === app
        );
        if (edit || copy) {
            newMenus.push(
                ...mappingData[0].details
                    .map((menu: any) => {
                        let newSubMenus =
                            app === menu.app_id ? menuLi : menu.menus;
                        if (app === menu.app_id && newSubMenus) {
                            const strMenus: any =
                                menuDetails &&
                                Object.keys(menuDetails.data).filter(
                                    (m: any) => {
                                        return menuDetails.data[m].length > 0;
                                    }
                                );
                            newSubMenus = newSubMenus.filter((sm: any) => {
                                return strMenus.includes(sm.type);
                            });
                        }
                        return {
                            app_id: menu.app_id,
                            menus: prepareMenuDetails(newSubMenus),
                        };
                    })
                    .filter((m: any) => m.menus.length > 0)
            );
        }
        if (!hasMappedMenu) {
            newMenus.push({ app_id: app, menus: prepareMenuDetails(menuLi) });
        }
        return newMenus;
    };
    const sleep = (ms: any) => {
        return new Promise((resolve) => setTimeout(resolve, ms));
    };
    const handleSave = useCallback(() => {
        if (status?.state === 'loading') {
            return;
        }

        const { device, role, user, name, partner } =
            detailsRef?.current?.getDetails() || {};

        if (!(name && role && menuDetails?.valid)) {
            setStatus({
                state: 'error',
                message: t('ui.mm.menu-mapping.notify.required-field-error'),
            });
            return;
        }

        menuMappingRef.current?.collapseAll();

        if (name && role && menuDetails?.valid) {
            const menuList = values(menuDetails.data).reduce((res, menu) => {
                res = res.concat(menu);
                return res;
            }, []);

            const data = mappingData?.[0];

            setStatus({
                state: 'loading',
                message: t('ui.mm.menu-mapping.notify.processing'),
            });

            apiClient
                .addMenuMapping({
                    ...(data?.id && !copy && { id: data.id }),
                    description: name,
                    details: prepareMenus(menuList),
                    device: device?.value || null,
                    role_id: role?.value || null,
                    partner_id: partner?.id || null,
                    user_id: user?.id || null,
                })
                .then(async (res: any) => {
                    if (res.success) {
                        setStatus({
                            state: 'success',
                            message: data?.id
                                ? t('ui.mm.menu-mapping.notify.update-success')
                                : t('ui.mm.menu-mapping.notify.create-success'),
                        });
                        await sleep(1000);
                        handleOnClose();
                    } else {
                        setStatus({
                            state: 'error',
                            message: res.error,
                        });
                    }
                })
                .catch((error) => {
                    setStatus({
                        state: 'error',
                        message: error,
                    });
                });
        }
    }, [details, menuDetails, menuMappingRef]);

    const onMenuDetailChange = useCallback((data: any) => {
        const parent = MENU_MAPPING_TYPES.reduce((res: boolean, m: any) => {
            if (data[m.name]?.length) {
                res = true;
            }
            return res;
        }, false);

        if (parent) {
            const valid = MENU_MAPPING_TYPES.reduce((res: boolean, m: any) => {
                if (data[m.name]?.length) {
                    const a = validateMenu(data[m.name]);
                    if (!a) {
                        res = false;
                    }
                }
                return res;
            }, true);

            setMenuDetails({
                valid,
                data,
            });
        } else {
            setMenuDetails({
                valid: edit ? true : false,
                data,
            });
        }
    }, []);

    return (
        <Modal
            isCentered
            closeOnOverlayClick={false}
            isOpen={isOpen}
            size="6xl"
            scrollBehavior={'inside'}
            onClose={handleOnClose}
        >
            <ModalOverlay
                style={{
                    backdropFilter: 'blur(5px)',
                }}
            />
            <ModalContent>
                <ModalHeader
                    color={currentColors.brand['10']}
                    fontSize="20px"
                    fontWeight="bold"
                    padding="15px"
                >
                    <Flex alignItems="center">
                        <Image
                            src={logo}
                            maxWidth="100%"
                            width="auto"
                            height={'35px'}
                            mr="17.5px"
                        />
                        <Text width="100%">
                            {t(
                                copy
                                    ? 'ui.mm.menu-mapping.copy-mappings'
                                    : !isEmpty(mappingData)
                                    ? 'ui.mm.menu-mapping.update-mappings'
                                    : 'ui.mm.menu-mapping.create-mappings'
                            )}
                        </Text>
                    </Flex>
                    <Divider
                        borderColor={currentColors.brand['700']}
                        width="100%"
                        mb="0px"
                    />
                </ModalHeader>
                <ModalCloseButton
                    as={() => (
                        <CanopyIconButton
                            background="transparent"
                            cursor="pointer"
                            border="none"
                            display="inline-flex"
                            onClick={handleOnClose}
                            color={currentColors.brand['500']}
                            width="24px"
                            height="24px"
                            aria-label="remove"
                            icon="ActClose"
                            variant="ghost"
                            position="absolute"
                            top="15px"
                            right="15px"
                        />
                    )}
                />
                <ModalBody>
                    <Flex display={['none', 'none', 'none', 'none', 'flex']}>
                        <Flex
                            width="25%"
                            minWidth="25%"
                            height="100%"
                        >
                            <Heading
                                as="h6"
                                size="md"
                                my="10px"
                                mx="0"
                            >
                                {t('menu-details')}
                            </Heading>
                        </Flex>
                        <Flex
                            width="75%"
                            height="100%"
                        >
                            <Heading
                                as="h6"
                                size="md"
                                my="10px"
                                px="4"
                                mx="0"
                            >
                                {t('mapping-details')}
                            </Heading>
                        </Flex>
                    </Flex>
                    <VStack
                        spacing="30px"
                        width="100%"
                    >
                        <Flex
                            width="100%"
                            border={`1px solid ${currentColors.componentBorder}`}
                        >
                            <Flex
                                align="flex-start"
                                width="100%"
                                p="10px"
                                direction={[
                                    'column',
                                    'column',
                                    'column',
                                    'column',
                                    'row',
                                ]}
                            >
                                <Heading
                                    as="h6"
                                    size="md"
                                    m="0"
                                    mt="10px"
                                    display={[
                                        'block',
                                        'block',
                                        'block',
                                        'block',
                                        'none',
                                    ]}
                                    px="20px"
                                    alignSelf="flex-start"
                                >
                                    {t('menu-details')}
                                </Heading>
                                <HStack
                                    px={4}
                                    width={[
                                        '100%',
                                        '100%',
                                        '100%',
                                        '100%',
                                        '25%',
                                    ]}
                                    minWidth={[
                                        '100%',
                                        '100%',
                                        '100%',
                                        '100%',
                                        '25%',
                                    ]}
                                    justifyContent="space-between"
                                >
                                    <MenuMappingDetails
                                        globalProps={globalProps}
                                        ref={detailsRef}
                                        data={details}
                                        disabled={status?.state === 'loading'}
                                    ></MenuMappingDetails>
                                </HStack>

                                <Divider
                                    display={[
                                        'none',
                                        'none',
                                        'none',
                                        'none',
                                        'block',
                                    ]}
                                    borderColor={currentColors.brand['700']}
                                    height="calc(100%)"
                                    mx={1}
                                    orientation="vertical"
                                />
                                <VStack
                                    width="100%"
                                    spacing={4}
                                    justifyContent="flex-start"
                                >
                                    <Box
                                        width="100%"
                                        justifyContent="flex-start"
                                        display={[
                                            'block',
                                            'block',
                                            'block',
                                            'block',
                                            'none',
                                        ]}
                                    >
                                        <Divider
                                            borderColor={
                                                currentColors.brand['700']
                                            }
                                            width="calc(100% - 40px)"
                                            mx="20px"
                                        />
                                        <Heading
                                            as="h6"
                                            size="md"
                                            mt={4}
                                            mb={0}
                                            px="20px"
                                            alignSelf="flex-start"
                                        >
                                            {t('mapping-details')}
                                        </Heading>
                                    </Box>
                                    {status?.message && (
                                        <Alert
                                            status={status.state}
                                            height="100%"
                                        >
                                            <AlertIcon />
                                            {status.message}
                                        </Alert>
                                    )}
                                    <HStack
                                        width="100%"
                                        alignItems="flex-start"
                                        justify="flex-end"
                                    >
                                        <MenuMapping
                                            ref={menuMappingRef}
                                            t={t}
                                            setApp={setApp}
                                            app={app}
                                            showAppDropDown={showModal}
                                            allMenus={
                                                app === 'micro-fe'
                                                    ? allMenu.concat(appOptions)
                                                    : allMenu
                                            }
                                            menuStructure={
                                                mappingData?.[0]?.details
                                            }
                                            edit={true}
                                            totalDepth={3}
                                            types={MENU_MAPPING_TYPES.filter(
                                                (appName: any) =>
                                                    appName.viewOn.includes(app)
                                            )}
                                            disabled={
                                                status?.state === 'loading'
                                            }
                                            onMenuDetailChange={
                                                onMenuDetailChange
                                            }
                                        />
                                    </HStack>
                                </VStack>
                            </Flex>
                        </Flex>
                        );
                    </VStack>
                </ModalBody>
                <ModalFooter
                    display="block"
                    padding="12px 15px"
                >
                    <Divider
                        mt="8px"
                        mb="8px"
                    />
                    <HStack
                        width="100%"
                        spacing="15px"
                        justifyContent="flex-end"
                    >
                        <Text as="b">
                            {t('ui.menu-mapping.save-button-note')}
                        </Text>
                        <CanopyButton
                            fontSize="sm"
                            width="100px"
                            fontWeight="bold"
                            disabled={status?.state === 'loading'}
                            isLoading={status?.state === 'loading'}
                            onClick={handleSave}
                        >
                            {t('save')}
                        </CanopyButton>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default CreateOrEditMenuMappingModal;
